// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-card.widget {
  margin: 0;
  height: 100%;
}

.widget-titolo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
}

.widget-link {
  margin-left: auto;
  font-size: 0.75rem;
  font-weight: normal;
  color: var(--ion-color-primary);
}

.widget-vuoto {
  font-size: 0.85rem;
  color: var(--ion-color-medium);
}

.pallino {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: none;
}

.barra-segmenti {
  display: flex;
  height: 14px;
  border-radius: 7px;
  overflow: hidden;
  background: var(--ion-color-light);
}
.barra-segmenti span {
  display: block;
  height: 100%;
}

.legenda-stati {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
}
.legenda-stati a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  color: var(--ion-text-color);
  text-decoration: none;
}
.legenda-stati a:hover, .legenda-stati a:focus-visible {
  color: var(--ion-color-primary);
  text-decoration: underline;
}

.numeri {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-top: 4px;
}
.numeri div {
  display: flex;
  flex-direction: column;
}
.numeri b {
  font-size: 1.1rem;
  color: var(--ion-text-color);
}
.numeri span {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ion-color-medium);
}

.numeri small {
  font-size: 0.75rem;
  color: var(--ion-color-medium);
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard-home/dashboard-widget.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAGA;EACE,SAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,8BAAA;AAAF;;AAGA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;AAAF;AAEE;EACE,cAAA;EACA,YAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AADF;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,4BAAA;EACA,qBAAA;AADJ;AAGI;EAEE,+BAAA;EACA,0BAAA;AAFN;;AAOA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAJF;AAME;EACE,aAAA;EACA,sBAAA;AAJJ;AAOE;EACE,iBAAA;EACA,4BAAA;AALJ;AAQE;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;AANJ;;AAUA;EACE,kBAAA;EACA,8BAAA;AAPF","sourcesContent":["// Stile comune ai widget della dashboard iniziale (feature 161).\n:host {\n  display: block;\n}\n\nion-card.widget {\n  margin: 0;\n  height: 100%;\n}\n\n.widget-titolo {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 1rem;\n}\n\n.widget-link {\n  margin-left: auto;\n  font-size: 0.75rem;\n  font-weight: normal;\n  color: var(--ion-color-primary);\n}\n\n.widget-vuoto {\n  font-size: 0.85rem;\n  color: var(--ion-color-medium);\n}\n\n.pallino {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex: none;\n}\n\n.barra-segmenti {\n  display: flex;\n  height: 14px;\n  border-radius: 7px;\n  overflow: hidden;\n  background: var(--ion-color-light);\n\n  span {\n    display: block;\n    height: 100%;\n  }\n}\n\n.legenda-stati {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 14px;\n  list-style: none;\n  margin: 10px 0 0;\n  padding: 0;\n\n  a {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 0.8rem;\n    color: var(--ion-text-color);\n    text-decoration: none;\n\n    &:hover,\n    &:focus-visible {\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n}\n\n.numeri {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 18px;\n  margin-top: 4px;\n\n  div {\n    display: flex;\n    flex-direction: column;\n  }\n\n  b {\n    font-size: 1.1rem;\n    color: var(--ion-text-color);\n  }\n\n  span {\n    font-size: 0.7rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--ion-color-medium);\n  }\n}\n\n.numeri small {\n  font-size: 0.75rem;\n  color: var(--ion-color-medium);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
